export const imagesPaths = [
    '/Images/Honey_Spice/outer_bar_render_2.jpeg',
    '/Images/Honey_Spice/bar_render_1.jpeg',
    '/Images/Honey_Spice/bar_render_2.jpeg'
    // '/Images/Cals_Office/MD_Office_render.jpeg',
]